module.exports = __webpack_public_path__ + "static/media/projects-barcelonacodeschool-billies-beer.334141c2.jpg";